export default "__VITE_ASSET__CF7HLuSD__"